import React from "react";
import { Handle } from "react-flow-renderer";
import { ArrowRight, BrainCircuit } from "lucide-react";
import { TimeIcon } from "../icons/FlowIcons";

// Entrada (target) - invisível, apenas funcional
export const TargetHandle = ({ isConnectable, top = "20px" }) => (
  <Handle
    type="target"
    position="left"
    style={{
      background: "var(--flow-handle-color)",
      width: "6px",
      height: "6px",
      top,
      left: "-3px",
      cursor: "pointer",
      border: "none",
      boxShadow: "0 0 3px var(--flow-node-shadow)",
    }}
    isConnectable={isConnectable}
  />
);

// Estilo glass compartilhado para os cards (usa CSS variables do tema)
export const glassStyle = {
  background: "var(--flow-node-bg)",
  backdropFilter: "blur(18px) saturate(1.2)",
  WebkitBackdropFilter: "blur(18px) saturate(1.2)",
  padding: "10px",
  borderRadius: "12px",
  boxShadow: "0 8px 26px var(--flow-node-shadow)",
  border: "1px solid var(--flow-node-border)",
};

// Estilo da linha de saida
const handleRowStyle = {
  position: "relative",
  marginTop: "5px",
  justifyContent: "flex-end",
  display: "flex",
  alignItems: "center",
  minHeight: "16px",
};

// Posicionamento do handle dentro da linha relativa
const rowHandleBase = {
  position: "absolute",
  right: "-13px",
  top: "50%",
  transform: "translateY(-50%)",
  width: "8px",
  height: "8px",
  cursor: "pointer",
};

// Saida Azul: Fluxo Normal
export const FlowOutputHandle = ({ isConnectable, id = "a" }) => (
  <div style={handleRowStyle}>
    <ArrowRight style={{ width: "10px", height: "10px", color: "var(--flow-text-secondary)", marginRight: "3px" }} />
    <div style={{ fontSize: "9px", color: "var(--flow-text-secondary)", fontWeight: "bold" }}>Fluxo Normal</div>
    <Handle
      type="source"
      position="right"
      id={id}
      style={{
        ...rowHandleBase,
        width: "7px",
        height: "7px",
        background: "var(--flow-handle-color)",
        border: "1px solid var(--flow-handle-color)",
        boxShadow: "0 0 4px var(--flow-node-shadow)",
      }}
      isConnectable={isConnectable}
    />
  </div>
);

// Saida Amarela: Sem resposta / Timeout
export const TimeoutOutputHandle = ({ isConnectable, label }) => (
  <div style={handleRowStyle}>
    <TimeIcon style={{ width: "12px", height: "12px", color: "var(--flow-text-secondary)", marginRight: "3px" }} />
    <div style={{ fontSize: "9px", color: "var(--flow-text-secondary)", fontWeight: "bold" }}>
      {label}
    </div>
    <Handle
      type="source"
      position="right"
      id="timeout"
      style={{
        ...rowHandleBase,
        width: "7px",
        height: "7px",
        background: "var(--flow-handle-color)",
        border: "1px solid var(--flow-handle-color)",
        boxShadow: "0 0 4px var(--flow-node-shadow)",
      }}
      isConnectable={isConnectable}
    />
  </div>
);

// Saida Roxa: Saida IA
export const AIOutputHandle = ({ isConnectable }) => (
  <div style={handleRowStyle}>
    <BrainCircuit style={{ width: "10px", height: "10px", color: "var(--flow-text-secondary)", marginRight: "3px" }} />
    <div style={{ fontSize: "9px", color: "var(--flow-text-secondary)", fontWeight: "bold" }}>
      Saida IA
    </div>
    <Handle
      type="source"
      position="right"
      id="ai"
      style={{
        ...rowHandleBase,
        width: "7px",
        height: "7px",
        background: "var(--flow-handle-color)",
        border: "1px solid var(--flow-handle-color)",
        boxShadow: "0 0 4px var(--flow-node-shadow)",
      }}
      isConnectable={isConnectable}
    />
  </div>
);

// Handle generico para opcoes de menu (dentro de row relativa) - verde claro
export const OptionOutputHandle = ({ isConnectable, id }) => (
  <Handle
    type="source"
    position="right"
    id={id}
    style={{
      ...rowHandleBase,
      width: "7px",
      height: "7px",
      background: "var(--flow-handle-color)",
      border: "1px solid var(--flow-handle-color)",
      boxShadow: "0 0 4px var(--flow-node-shadow)",
    }}
    isConnectable={isConnectable}
  />
);

// Estilo da linha de opcao (para menu e randomizer)
export const optionRowStyle = {
  position: "relative",
  marginBottom: "6px",
  justifyContent: "flex-end",
  display: "flex",
  alignItems: "center",
  minHeight: "16px",
};

// SourceHandle legado (para nodes simples que so tem 1 saida)
export const SourceHandle = ({ isConnectable, id = "a", top = "70%" }) => (
  <Handle
    type="source"
    position="right"
    id={id}
    style={{
      background: "var(--flow-handle-color)",
      width: "7px",
      height: "7px",
      top,
      right: "-6px",
      cursor: "pointer",
      border: "1px solid var(--flow-handle-color)",
      boxShadow: "0 0 4px var(--flow-node-shadow)",
    }}
    isConnectable={isConnectable}
  />
);

